import { FingerPrintIcon as AdminIcon } from "@heroicons/react/24/solid";
import * as Accordion from "@radix-ui/react-accordion";
import { FC, useCallback, useState } from "react";
import SidebarLink from "./SidebarLink";
import SidebarGroup from "./SidebarGroup";
import { useAuth } from "@hooks";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import { ROSwitcher } from "@components/ROSwitcher";

const AccrualsIcon = () => <AssuredWorkloadIcon />;
const Sidebar: FC = () => {
    const { session } = useAuth();
    const [openLabel, setOpenLabel] = useState(
        localStorage.getItem("openNavGroup") ?? "",
    );
    const handleOpenLabelChange = useCallback(
        (label: string) => {
            localStorage.setItem("openNavGroup", label);
            setOpenLabel(label);
        },
        [setOpenLabel],
    );

    return (
        <aside
            className={
                "sticky inset-y-0 left-0 flex h-screen w-56 min-w-[250px] flex-col overflow-hidden border-r border-secondary-gray-2 bg-secondary-gray-0 transition-all"
            }
        >
            <div className="self-center">
                <ROSwitcher />
            </div>
            <nav>
                <Accordion.Root
                    type="single"
                    onValueChange={(value) => {
                        handleOpenLabelChange(value);
                    }}
                    value={openLabel}
                    collapsible
                    className="flex flex-col gap-2 px-2.5"
                >
                    {session?.isAdmin ? (
                        <SidebarLink
                            location="/admin"
                            label="Admin"
                            Icon={AdminIcon}
                        />
                    ) : null}

                    <SidebarGroup
                        Icon={AccrualsIcon}
                        handleOpenLabelChange={handleOpenLabelChange}
                        label="Accruals"
                    >
                        <SidebarLink
                            location="/accruals/account-matching"
                            label="Payment Methods"
                        />
                        <SidebarLink
                            location="/accruals/vendor-matching"
                            label="Vendors"
                        />

                        <SidebarLink
                            location="/chart-of-accounts"
                            label="Chart of Accounts"
                        />
                        <SidebarLink
                            location="/integrations/unified"
                            label="ERP Connection"
                        />
                    </SidebarGroup>
                </Accordion.Root>
            </nav>
        </aside>
    );
};

export default Sidebar;
